export default __webpack_public_path__ + "static/media/sustainalytics-badge.033fe264.png";